import React from 'react'
import Head from 'next/head'
import Link from 'next/link'
import Hero from '../components/Hero'
import Menu from '../components/Menu'
import Block from '../components/Block'
import { NextSeo } from 'next-seo';
import Footer from '../components/Footer'

const Goodies = () =>
  <div id="main-container">
    <NextSeo
      title='Goodies | PyCon mini Hiroshima 2020 '
      description='Goodies of PyCon mini Hiroshima 2020'
      openGraph={{
        title: 'Goodies | PyCon mini Hiroshima 2020',
        description: 'つまらないものですが PyCon mini Hiroshima 2020 からです。お受け取りください。'
      }}
    />
    <NextSeo 
    />
    <header>
      <Menu />
    </header>
    <div role='main'>
      <div>
        <h1 className='block'>🎁Goodies</h1>
      </div>
    
      <Block title='Virtual backgrounds' backgroundClass='not-center'>
        <p>PyCon mini Hiroshima 2020 <b>特製バーチャル背景画像</b>です。是非Zoomで設定してご参加ください。</p>
        <p style={{textAlign: 'center'}}>
          <img src='./images/pyconhiro-bg-right-side-open-thumbnail.png' style={{maxWidth: '100%'}}/>
        </p>
        <ul>
          <li>カメラの向きが水平に近い方におすすめのスタイルです。</li>
          <ul>
            <li><Link href='./images/pyconhiro-bg-right-side-closed.png'><a>スタンダード・ルーム (1920 x 1080)</a></Link></li>
            <li><Link href='./images/pyconhiro-bg-right-side-open.png'><a>右の窓も開けてやや明るいルーム (1920 x 1080)</a></Link></li>

          </ul>
          <li>ノートパソコンのカメラなど、カメラがやや上向きの方向けのスタイルです。</li>
          <ul>
            <li><Link href='./images/pyconhiro-bg-up-right-side-closed.png'><a>スタンダード・ルーム (1920 x 1080)</a></Link></li>
            <li><Link href='./images/pyconhiro-bg-up-right-side-open.png'><a>右の窓も開けてやや明るいルーム (1920 x 1080)</a></Link></li>
          </ul>
          <li>動画もご用意いたしました。</li>
          <ul>
            <li><Link href='./images/pyconhiro-bg.mp4'><a>動画 (1280 x 720)</a></Link></li>
          </ul>
        </ul>
        <p>
          <a href='https://fshare.hiroshima-u.ac.jp/nextcloud/index.php/s/EbAcstMdxE5ywbd'>まとめてダウンロード (zip, 2.6 MB)</a>
        </p>
      </Block>

    </div>

    <Footer/>
  </div>

export default Goodies;


